module.exports = __webpack_public_path__ + "img/leftArrowWhite.b66e4e96.svg";